export default __webpack_public_path__ + "static/media/sticker-Z.e1011f09.png";